import React from 'react';
import PartnerForm from './PartnerForm'; // Importez le composant PartnerForm

const CreatePartner = () => {
  return <PartnerForm isEdit={false} />;
};

export default CreatePartner;
